<script lang="ts">
	import type { Snippet } from 'svelte';

	let {
		class: className = '',
		children,
		...restProps
	}: {
		class?: string;
		children: Snippet;
	} & Record<string, unknown> = $props();
</script>

<div
	class="rounded-lg border border-gray-200 bg-white shadow-sm transition-shadow hover:shadow-md {className}"
	{...restProps}
>
	<div class="p-6">
		{@render children()}
	</div>
</div>
